// import { toast } from "react-toastify";
import axiosInstance from "./axiosInstance";

const showErrorToast = (error) => {
  const errorMessage =
    error.response?.data?.message || error.message || "Something went wrong";
  // toast.error(errorMessage);
};

// Reusable API Methods
export const getApi = async ({ apiUrl, headers = {} }, showError = false) => {
  try {
    const response = await axiosInstance.get(`${apiUrl}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    if (showError) {
      showErrorToast(error);
    } else {
      throw new Error(error.response?.data?.message || error.message || "Something went wrong");
    }
  }
};

export const postApi = async (
  { apiUrl, data = {}, headers = {} },
  showError = false
) => {
  try {
    const response = await axiosInstance.post(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    if (showError) {
      showErrorToast(error);
    } else {
      throw new Error(error.response?.data?.message || error.message || "Something went wrong");
    }
  }
};

export const putApi = async (
  { apiUrl, data = {}, headers = {} },
  showError = false
) => {
  try {
    const response = await axiosInstance.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    if (showError) {
      showErrorToast(error);
    } else {
      throw new Error(error.response?.data?.message || error.message || "Something went wrong");
    }
  }
};

export const patchApi = async (
  { apiUrl, data = {}, headers = {} },
  showError = false
) => {
  try {
    console.log("PATCH Request to:", apiUrl); // Debugging Log
    const response = await axiosInstance.patch(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    if (showError) {
      showErrorToast(error);
    } else {
      throw new Error(error.response?.data?.message || error.message || "Something went wrong");
    }
  }
};

export const deleteApi = async (
  { apiUrl, data = {}, headers = {} },
  showError = false
) => {
  try {
    const response = await axiosInstance.delete(apiUrl, {
      data,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    if (showError) {
      showErrorToast(error);
    } else {
      throw new Error(error.response?.data?.message || error.message || "Something went wrong");
    }
  }
};
